import script from "./web-app-login.vue?vue&type=script&setup=true&lang=js"
export * from "./web-app-login.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__